import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button, Typography, Container, CssBaseline, TextField, withStyles } from '@material-ui/core';
import { isMobile, isBrowser, isChrome } from 'react-device-detect';
import { history } from '../../helpers/history';
import {themeLogin} from "../../styles/LoginTheme"
// import { ThemeProvider } from '@material-ui/styles';
// import { inputBase } from "./../../styles/TextFieldTheme";
// import ArrowBackIcon from '@material-ui/icons/ArrowBack';
// import RenderDecimalTextField from '../Complements/renderDecimalTextFiel';
// import renderCheckbox from '../Complements/renderCheckbox';

const validate = values => {
  const error = {}
  /* if (!values.provisional) {
      error.provisional = "La cedula es requerida"
  } */
  if (!values.account) {
    error.account = "El campo es obligatorio"
  }
  if (!values.passwordNew) {
    error.passwordNew = "El campo es obligatorio"
  }
  if (!values.passwordRepeat) {
    error.passwordRepeat = "El campo es obligatorio"
  }
  if (values.passwordRepeat !== values.passwordNew) {
    error.passwordNew = "Las contraseñas no coinciden"
    error.passwordRepeat = "Las contraseñas no coinciden"
  }
  return error
}

const useStyles = () => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: "1% 6% 6% 6%",
  },
  avatar: {
    margin: 1,
    backgroundColor: 'red',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: (3, 0, 2),
    fontWeight: 'bold',
    fontSize: '0.9rem',
    color: 'white',
    backgroundColor: "#0097a0",
    "&:hover": {
      backgroundColor: "#0097a0"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  logo: {
    width: '40%',
    height: '40%'
  },
  button_header: {
    marginTop: 20,
  },
  grid_header: {
    marginTop: 20,
  },
  copyright: {
    justifyContent: 'space-between'
  },
  title: {
    color: themeLogin.palette.primary.main,
    //fontFamily: 'Roboto-Bold'
    // fontWeight: 'bold',
    // fontSize: '200%'
  },
  button: {
    fontSize: '0.875rem',
    color: 'white',
    background: '#0097a0',
    "&:hover": {
      backgroundColor: "#0097a0"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  buttonStandard: {
    fontSize: '1rem',
    color: '#ffffff',
    borderRadius: '4px',
    '&.Mui-disabled': {
        backgroundColor: "#a7a8a8",
    },
    '&:hover': {
        backgroundColor: "#706D85",
    },
    backgroundColor: "#2E2757",
    //fontFamily: 'MyriadPro-Bold',
},
});

// function Copyright(classes) {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center"  >
//       <Grid container className= {classes.grid_header} justify="center" alignItems="center" >
//         <Grid item xs={3}  className= {classes.button_header}>
//           <img src={process.env.PUBLIC_URL + '/images/copyright_icon.png'} alt="Logo" className={classes.logo}  />
//         </Grid>
//         <Grid item xs={6} justify="center" alignItems="center" >
//           <Link color="primary" href={ urlBase }>
//             <b>DERECHOS RESERVADOS</b>
//           </Link>{' '}
//         </Grid>
//       </Grid>          
//     </Typography>
//   );
// }
class CheckUser extends Component {
  state = {}
  renderTextField = (
    { input, label, name, type, withFocus, meta: { touched, error } },
  ) => (
    
      <div>
        {/* <ThemeProvider theme={inputBase}> */}
          <TextField
            {...input}
            type={!type ? "text" : type}
            variant="outlined"
            margin="normal"
            fullWidth
            color={'primary'}
            /*  style={{
              "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                  border: `5px dotted red`
                }
              }
            }} */
            name={label}
            id={label}
            placeholder={label}
            ref={withFocus && (txt => { this.txt = txt; })}
          />
        {/* </ThemeProvider> */}
      </div>
  );
  /* renderTextField = (
      { input, label, name, type, withFocus, meta: { touched, error } },
    ) => (
      <div>
        <br/>
        <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
          <Grid item xs={12} md={12}>
            <span style={{color:'#706D85', fontSize : "120%", //fontFamily : 'Roboto-Bold'}}>{label}</span>
          </Grid>
        </Grid>
        <TextField
          {...input}
          type={!type ? "text" : type}
          variant="standard"
          margin="normal"
          style={{backgroundColor: 'white'}}
          fullWidth
          name={label}
          id={label}
          label={''}
          InputLabelProps= {
            {
              style: { color: '#fffffe'}
            }
          }
          ref={withFocus && (txt => { this.txt = txt;} ) }
          InputProps={{
            style : {
              height : "100px"
            },
            startAdornment: (
              <InputAdornment position="start" style={{backgroundColor: '#Fa5521'}}>
                  
              </InputAdornment>
            ),
          }}
        />
      </div>
    ); */
  render() {
    const { classes, handleSubmit, pristine, submitting, valid } = this.props; //,  valid, submitting
    
    return (
      <div>
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          <div className={classes.paper}>
            <br />

            {
              isMobile ?
                <img src={process.env.PUBLIC_URL + '/images/logo_movil_cl.png'} alt="Logo" style={{ width: '80%', height: '80%' }} /> :
                <img src={process.env.PUBLIC_URL + '/images/logo_en_cl.png'} alt="Logo" style={{ width: '100%'/* , height: '80%' */ }} />
            }
            <br></br>
            <Typography variant="h5" className={classes.title}>
              {(isMobile && !isBrowser && !isChrome) ? 'Recuperar contraseña' : 'Recuperar contraseña'}
            </Typography>
            <form className={classes.form} onSubmit={handleSubmit} id="myForm">
              <Field
                withFocus
                name="identifier"
                component={this.renderTextField}
                label="Escriba su nombre de usuario"
                
              />
              {/* <br></br> */}
              <Field
                withFocus
                name="account"
                required
                component={this.renderTextField}
                label="Escriba su número de cuenta de ahorros"
                
              />
              <br></br>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} >
                  <Button
                    type="submit"
                    name="buttonSubmit"
                    disabled={pristine || submitting || !valid}
                    fullWidth
                    variant='contained'
                    color='primary'
                    /* style={{
                      fontSize: '0.875rem',
                      color: '#000000',
                      background: '#e0e0e0',
                      "&:hover": {
                        backgroundColor: "#e0e0e0"
                      },
                      borderRadius: "8px",
                      //border: "1px solid #fffffe",
                      //fontFamily: "Roboto-Bold"
                    }} */
                    // className={classes.buttonStandard}
                  >
                    Aceptar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} xl={6} >
                  <Button
                    onClick={() => history.push('/login')}
                    variant='contained'
                    color='secondary'
                    fullWidth
                    // className={classes.buttonStandard}

                    /* style={{
                      fontSize: '0.875rem',
                      color: '#FFFFFF',
                      background: '#372d2d',
                      "&:hover": {
                        backgroundColor: "#372d2d"
                      },
                      borderRadius: "8px",
                      //border: "1px solid #eeeff2",
                      //fontFamily: "Roboto-Bold"
                    }} */
                  // startIcon = { <ArrowBackIcon /> }

                  > Atrás</Button>
                </Grid>
              </Grid>
            </form>
          </div>
          {/* <Box mt={8}>
          <Copyright classes = {classes}/>
          </Box> */}
        </Container>
      </div>
    );
  }
}

CheckUser.propTypes = {

};

const CheckUserReduxForm = reduxForm(
  {
    form: 'CheckUserdForm',
    validate
  }
)(CheckUser)

// export default ChangePasswordForm;
export default setPropsAsInitial(withStyles(useStyles)(CheckUserReduxForm))